import { createRouter, createWebHistory } from 'vue-router'
import AddComplain from '../views/Add/Complain.vue'
import AddComplaint_Type from '../views/Add/Complaint_Type.vue'
import AddIdentity from '../views/Add/Identity.vue'
import AddNationality from '../views/Add/Nationality.vue'
import AddQuiz from '../views/Add/Quiz.vue'
import AddDetictive from '../views/Add/Detictive.vue'
import Adddistrict from '../views/Add/district.vue'
import AddGov from '../views/Add/Gov.vue'
import AddEducation_Level from '../views/Add/Education_Level.vue'
import AddComplaint_Procedures from '../views/Add/Complaint_Procedures.vue'
import AddMarital_Status from '../views/Add/Marital_Status.vue'
import AddStatus_Type from '../views/Add/Status_Type.vue'
import AddDirectorates from '../views/Add/Directorates.vue'
import AddComplaint_Recipient from '../views/Add/Complaint_Recipient.vue'
import AddCity from '../views/Add/City.vue'
import AddRes from '../views/Add/Res.vue'
import AddRecord from '../views/Add/Record.vue'
import districtView from '../views/List/district.vue'
import Education_LevelView from '../views/List/Education_Level.vue'
import _404 from '../views/List/_404.vue'
import ViewGov from '../views/List/Gov.vue'
import ViewDirectorates from '../views/List/Directorates.vue'
import AccusedView from '../views/List/Accused.vue'
import Complaint_ProceduresView from '../views/List/Complaint_Procedures.vue'
import Marital_StatusView from '../views/List/Marital_Status.vue'
import Status_TypeView from '../views/List/Status_Type.vue'
import Complaint_RecipientView from '../views/List/Complaint_Recipient.vue'
import CityView from '../views/List/City.vue'
import Complaint_TypeView from '../views/List/Complaint_Type.vue'
import NationalityView from '../views/List/Nationality.vue'
import ViewRes from '../views/List/Res.vue'
import ComplainView from '../views/List/Complain.vue'
import DetictiveView from '../views/List/Detictive.vue'
import QuizView from '../views/List/Quiz.vue'
import IdentityView from '../views/List/Identity.vue'
import RecordView from '../views/List/Record.vue'
import EditCity from '../views/Edit/City.vue'
import EditDirectorates from '../views/Edit/Directorates.vue'
import EditGov from '../views/Edit/Gov.vue'
import Editdistrict from '../views/Edit/district.vue'
import EditRes from '../views/Edit/Res.vue'
import EditDetictive from '../views/Edit/Detictive.vue'
import ComplainPrint from '../views/List/ComplainPrint.vue'


const routes = [
  {
    path: '/',
    redirect: {name: 'ComplainView'}
  },
  {
    path: '/ComplainPrint/:id', 
    name: 'ComplainPrint',
    component: ComplainPrint,
    props:true
},
  {
    path: '/EditCity/:id', 
    name: 'EditCity',
    component: EditCity,
    props:true
},
  {
    path: '/EditDetictive/:id', 
    name: 'EditDetictive',
    component: EditDetictive,
    props:true
},
  {
    path: '/EditRes/:id', 
    name: 'EditRes',
    component: EditRes,
    props:true
},
  {
    path: '/Editdistrict/:id', 
    name: 'Editdistrict',
    component: Editdistrict,
    props:true
},
  {
    path: '/EditDirectorates/:id', 
    name: 'EditDirectorates',
    component: EditDirectorates,
    props:true
},
  {
    path: '/EditGov/:id', 
    name: 'EditGov',
    component: EditGov,
    props:true
},
  {
    path: '/districtView', 
    name: 'districtView',
    component: districtView
},
  {
    path: '/IdentityView', 
    name: 'IdentityView',
    component: IdentityView
},
  {
    path: '/Marital_StatusView', 
    name: 'Marital_StatusView',
    component: Marital_StatusView
},
  {
    path: '/NationalityView', 
    name: 'NationalityView',
    component: NationalityView
},
  
  {
    path: '/AccusedView/:id', 
    name: 'AccusedView',
    component: AccusedView,
    props: true
},
  {
    path: '/RecordView', 
    name: 'RecordView',
    component: RecordView
},
  {
    path: '/Complaint_RecipientView', 
    name: 'Complaint_RecipientView',
    component: Complaint_RecipientView
},
  {
    path: '/Education_LevelView', 
    name: 'Education_LevelView',
    component: Education_LevelView
},
  {
    path: '/Status_TypeView', 
    name: 'Status_TypeView',
    component: Status_TypeView
},
  {
    path: '/Complaint_TypeView', 
    name: 'Complaint_TypeView',
    component: Complaint_TypeView
},
  {
    path: '/QuizView:id', 
    name: 'QuizView',
    component: QuizView,
    props:true
},
  {
    path: '/DetictiveView', 
    name: 'DetictiveView',
    component: DetictiveView
},
  {
    path: '/Complaint_ProceduresView', 
    name: 'Complaint_ProceduresView',
    component: Complaint_ProceduresView
},
  {
    path: '/ComplainView', 
    name: 'ComplainView',
    component: ComplainView
},
  {
    path: '/ViewRes', 
    name: 'ViewRes',
    component: ViewRes
},
  {
    path: '/CityView', 
    name: 'CityView',
    component: CityView
},
  {
    path: '/ViewDirectorates', 
    name: 'ViewDirectorates',
    component: ViewDirectorates
},
  {
    path: '/ViewGov', 
    name: 'ViewGov',
    component: ViewGov
},
  {
    path: '/AddComplain', 
    name: 'AddComplain',
    component: AddComplain
},
  {
    path: '/AddRecord', 
    name: 'AddRecord',
    component: AddRecord
},
  {
    path: '/AddCity', 
    name: 'AddCity',
    component: AddCity
},
  {
    path: '/AddIdentity', 
    name: 'AddIdentity',
    component: AddIdentity
},
  {
    path: '/AddStatus_Type', 
    name: 'AddStatus_Type',
    component: AddStatus_Type
},
  {
    path: '/AddEducation_Level', 
    name: 'AddEducation_Level',
    component: AddEducation_Level
},
  {
    path: '/AddMarital_Status', 
    name: 'AddMarital_Status',
    component: AddMarital_Status
},
  {
    path: '/AddComplaint_Recipient', 
    name: 'AddComplaint_Recipient',
    component: AddComplaint_Recipient
},
  {
    path: '/AddComplaint_Procedures', 
    name: 'AddComplaint_Procedures',
    component: AddComplaint_Procedures
},
  {
    path: '/AddNationality', 
    name: 'AddNationality',
    component: AddNationality
},
  {
    path: '/AddComplaint_Type', 
    name: 'AddComplaint_Type',
    component: AddComplaint_Type
},
  {
    path: '/AddRes', 
    name: 'AddRes',
    component: AddRes
},
  {
    path: '/AddDirectorates', 
    name: 'AddDirectorates',
    component: AddDirectorates
},
  {
    path: '/AddGov', 
    name: 'AddGov',
    component: AddGov
},
  {
    path: '/Adddistrict', 
    name: 'Adddistrict',
    component: Adddistrict
},
  {
    path: '/AddDetictive', 
    name: 'AddDetictive',
    component: AddDetictive
},
  {
    path: '/AddQuiz/:id', 
    name: 'AddQuiz',
    component: AddQuiz,
    props:true
},
{
  path: '/:catchAll(.*)', 
  name: '_404',
  component: _404,
},
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
